import { createSelector } from '@reduxjs/toolkit';
import { Strategy } from 'client/voladeum/strategies/types';
import { RootState } from 'store';

const strategySlice = (state: RootState) => state.strategy;

export const selectStrategy = createSelector([strategySlice], (state): Strategy => state);
